export default __webpack_public_path__ + "static/media/jira-brands.edb8c104.svg";